export default "__VITE_ASSET__f11994d1__"